import _ from "lodash";
import { computed } from "mobx";
import { useMemo } from "react";
import { usePipedriveStore } from "..";
import useDealsWithFocusArea from "./useDealsWithFocusArea";
import useDealsWithGlobalFilters from "./useDealsWithGlobalFilters";

export default function () {
    const pipedriveStore = usePipedriveStore();
    const deals = useDealsWithFocusArea(useDealsWithGlobalFilters(pipedriveStore.deals));

    return useMemo(() => computed(() => {
        const availableOwners = _.sortBy(pipedriveStore.users.filter(u => deals.some(d => d.assignedToUserId === u.id)).map(u => u.name));

        return ["All Owners"].concat(availableOwners);
    }), [deals]).get();
}